var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tr", [
    _c("td", [
      _c("div", { staticClass: "form-field" }, [
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("input-field", {
              attrs: {
                id: "codigo_barra" + _vm.index,
                readonly: _vm.modelValue.item_id != "",
                placeholder: "Escriba un código de barra..."
              },
              on: {
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.consultarCodigoBarra.apply(null, arguments)
                }
              },
              model: {
                value: _vm.modelValue.codigo_barra,
                callback: function($$v) {
                  _vm.$set(_vm.modelValue, "codigo_barra", $$v)
                },
                expression: "modelValue.codigo_barra"
              }
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.modelValue.item_id == "",
                    expression: "modelValue.item_id == ''"
                  }
                ],
                staticClass: "btn-success btn--text",
                attrs: { type: "button" },
                on: { click: _vm.consultarCodigoBarra }
              },
              [_c("i", { staticClass: "fa fa-check" })]
            )
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("td", [
      _c(
        "div",
        {
          staticClass: "form-field select2",
          class: {
            "select2--disabled": true
          }
        },
        [
          _c(
            "div",
            { staticClass: "select2-field" },
            [
              _c("v-select", {
                attrs: {
                  options: _vm.items,
                  label: "nombre",
                  id: "item" + _vm.index
                },
                on: { input: _vm.inputItem, search: _vm.searchItem },
                model: {
                  value: _vm.selectedItem,
                  callback: function($$v) {
                    _vm.selectedItem = $$v
                  },
                  expression: "selectedItem"
                }
              })
            ],
            1
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c("td", [
      _c(
        "div",
        { staticClass: "form-field" },
        [
          _c("input-field", {
            attrs: {
              id: "cantidad" + _vm.index,
              vMoney: "",
              format: _vm.decimal,
              readonly: ""
            },
            model: {
              value: _vm.modelValue.cantidad,
              callback: function($$v) {
                _vm.$set(_vm.modelValue, "cantidad", $$v)
              },
              expression: "modelValue.cantidad"
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("td")
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3cb196fe", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cb196fe","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/visitas/TrItemVisita.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-3cb196fe","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/visitas/TrItemVisita.vue
// module chunks = 0